// extracted by mini-css-extract-plugin
export default {"wrapper":"o2-z","play":"p2-z"};